import { BillingMethodEnum } from "@enums/billingMethodEnum.enum"
import { UserDto } from "./userDto"

export class PricingDto  {
  id: number
  ownerUserId: string
  productId: string
  priceId: string
  
  type: string
  billingMethod: BillingMethodEnum
  name: string
  description: string
  price: number
  priceDc: number
  isPublic: boolean
  isArchived: boolean
  created: Date
  hasStartingFee: boolean
  startingFeeAmount: number | null
  
  selectedUsers?: UserDto[]

  constructor(formValue?: Partial<PricingDto>) {
    Object.assign(this, formValue)
  }

  updateValues(formValue: Partial<PricingDto>) {
    Object.assign(this, formValue)
  }

  getPrimaryKey() {
    return this.id
  }
}
